import React from "react";
import { Article } from "../../../../components/groups";

interface ContentSectionProps {
  t: any;
  showAdditionalParagraph?: boolean;
}

const ContentSection: React.FC<ContentSectionProps> = ({ t, showAdditionalParagraph }) => (
  <div className="container-flow flex-grow mt-6 md:mt-[12rem] mb-8">
    <div className="flex gap-10">
      <div className="w-full">
        <h2 className="font-serif font-bold text-3xl md:text-4xl mb-4">{t("title")}</h2>
        <Article>
          <p className="mb-0 mt-F4">{t("content")}</p>
          <p className="mt-8 mb-8 md:mb-0">
            <div>{t("content1")}</div>
            <div>{t("content2")}</div>
            {showAdditionalParagraph && <div className="mt-4">{t("content3")}</div>}
          </p>
        </Article>
      </div>
    </div>
  </div>
);

export default ContentSection;
